<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      shape="square"
      finish-button-text="Save"
      back-button-text="Previous"
      class="mb-3"
      @on-complete="formSubmitted"
    >
      <!-- accoint details tab -->
      <tab-content
        title="Adding New User"
        icon="feather icon-file-text"
        :before-change="onSubmit"
      >
        <validation-observer ref="accountRules" tag="form">
          <b-row>
            <!-- Name -->
            <b-col md="6">
              <b-form-group label="First Name *" label-for="firstName">
                <validation-provider
                  #default="{ errors }"
                  name="firstName"
                  rules="required"
                >
                  <b-form-input
                    v-on:keypress="isLetter($event)"
                    id="firstName"
                    v-model="requestData.firstName"
                    type="text"
                    :state="errors.length > 0 ? false : null"
                    placeholder="First Name"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!--Last Name -->
            <b-col md="6">
              <b-form-group label="Last Name *" label-for="lastName">
                <validation-provider
                  #default="{ errors }"
                  name="lastName"
                  rules="required"
                >
                  <b-form-input
                    v-on:keypress="isLetter($event)"
                    id="lastName"
                    v-model="requestData.lastName"
                    type="text"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Last Name"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Access Type  -->

            <!-- Username -->
            <b-col md="6">
              <b-form-group label="Username *" label-for="Username">
                <validation-provider
                  #default="{ errors }"
                  rules="required"
                  name="Username"
                >
                  <b-form-input
                    id="Username"
                    v-model="requestData.username"
                    type="email"
                    placeholder="Username"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="3" v-if="allRoles">
              <b-form-group label="Role *" label-for="Role">
                <validation-provider
                  #default="{ errors }"
                  name="Role"
                  rules="required"
                >
                  <v-select
                    v-model="requestData.roleId"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="allRoles"
                    :getOptionLabel="(requestData) => requestData.roleId"
                    input-id="role"
                  >
                    <template #option="{ name }">
                      <span class="ml-50 align-middle"> {{ name }}</span>
                    </template>

                    <template #selected-option="{ name }">
                      <span class="ml-50 align-middle"> {{ name }}</span>
                    </template>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="3" v-if="allMerchants">
              <b-form-group label="Merchant" label-for="Merchant">
                <validation-provider
                  #default="{ errors }"
                  name="Merchant"
                  rules="required"
                >
                  <v-select
                    v-model="requestData.merchantId"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="allMerchants"
                    :getOptionLabel="(requestData) => requestData.merchantId"
                    input-id="merchant"
                  >
                    <template #option="{ name }">
                      <span class="ml-50 align-middle"> {{ name }}</span>
                    </template>

                    <template #selected-option="{ name }">
                      <span class="ml-50 align-middle"> {{ name }}</span>
                    </template>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Password -->
            <b-col md="6">
              <b-form-group label="Password *" label-for="Password">
                <validation-provider
                  #default="{ errors }"
                  rules="required"
                  vid="Password"
                  name="Pasword"
                >
                  <b-form-input
                    id="Pasword"
                    v-model="requestData.password"
                    type="password"
                    placeholder="Pasword"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Confirm Password -->
            <b-col md="6">
              <b-form-group
                label="Confirm Password *"
                label-for="Confirm Password"
              >
                <validation-provider
                  #default="{ errors }"
                  rules="required|confirmed:Password"
                  name="ConfirmPassword "
                >
                  <b-form-input
                    id="Confirm Password "
                    v-model="confirmPassword"
                    type="password"
                    placeholder="Confirm Password"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import axios from "@axios";
import vSelect from "vue-select";
import { required, email } from "@validations";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BOverlay,
  BCardTitle,
  BCard,
  BCardText,
  BFormInvalidFeedback,
} from "bootstrap-vue";

export default {
  name: "AddAdvancePayment",
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BFormCheckbox,
    BOverlay,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BCardTitle,
    BCard,
    BCardText,
    BFormInvalidFeedback,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      isLoading: false,
      confirmPassword: "",
      requestData: {
        password: "Hsyei#@87698",
        username: "user@example.com",
        firstName: "string",
        lastName: "string",
        roleId: 0,
        merchantId: 0,
      },
      required,
      email,
      checkedmerchantIds: [],
      allmerchantIdsCounter: 0,
      // Options
      roles: [],
      allMerchantIds: [], // JSON.parse(localStorage.getItem('companies')),
      companyIds: [], // JSON.parse(localStorage.getItem('companies')).filter(m => m.id),
      allMerchants: null,
      allRoles: null,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[a-zA-Z\s]*$/.test(char)) return true; // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    formSubmitted() {
      this.$refs.accountRules.reset();
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Data Submitted",
          icon: "EditIcon",
          variant: "success",
        },
      });
    },

    fetchData() {
      this.$store.dispatch("config/getActionPrivilege", "ClientRole-GetAll");
      this.isLoading = true;
      axios
        .get("/User/api/V1.0/ClientRole/GetAll")
        .then((res) => {
          this.allRoles = res.roles;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
      this.isLoading = true;
      axios
        .get("Merchant/api/V1.0/Merchants/GetMerchants")
        .then((res) => {
          this.isLoading = false;
          this.allMerchants = res.merchants;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },

    onSubmit() {
      this.$store.dispatch("config/getActionPrivilege", "ClientAccount-Add");
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then((success) => {
          if (success) {
            this.requestData.roleId = this.requestData.roleId.id;
            this.requestData.merchantId = this.requestData.merchantId.id;
            this.isLoading = true;
            axios
              .post("/api/V1.0/ClientAccount/Add", this.requestData)
              .then((res) => {
                if (res.status) {
                  this.isLoading = false;

                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Record Added",
                      icon: "BellIcon",
                      variant: "Success",
                      text: `${res.data.message}`,
                    },
                  });
                  this.$router.push("/account-Management/client-users");
                  resolve(true);
                }
              })
              .catch((res) => {
                this.isLoading = false;
                reject(res);

                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Error",
                    icon: "BellIcon",
                    variant: "danger",
                    text: `${res.data.message}`,
                  },
                });
              });
          } else {
            reject();
          }
        });
      });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
